import { render, staticRenderFns } from "./OrderParts.vue?vue&type=template&id=7ee10468&"
import script from "./OrderParts.vue?vue&type=script&lang=ts&"
export * from "./OrderParts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports